import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchRobinsonComponent } from './search/components/search-robinson/search-robinson.component';
import { SharedModule } from '../shared/shared.module';
import {SearchRobinsonService} from './search/services/search-robinson.service';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    providers: [
        SearchRobinsonService
    ],
    declarations: [SearchRobinsonComponent]
})
export class RobinsonModule { }



// WEBPACK FOOTER //
// /var/www/backend/src/app/robinson/robinson.module.ts